export default __webpack_public_path__ + "static/media/montenegro.108f1a63.webp";